<template>
    <div class="container-nzidoo">
        <div class="row d-none" v-if="userUpdate.validated_client !== 1">
            <div v-if="userUpdate.card_id === null || userUpdate.card_id === undefined"
                class="col-8 offset-2 text-center alert alert-info">
                {{ $t("sentence.toBecomeAXPleaseFillUpTheInfo", { subject: $t("actor.seller") }) }}
            </div>
            <div v-if="userUpdate.card_id !== null && userUpdate.card_id !== undefined"
                class="col-8 offset-2 text-center alert alert-info">
                {{ $t("sentence.yourRequestIsInProgressYouWillReceiveAnEmailSoon") }}
            </div>
        </div>
        <loading-spinner v-if="loader" />
        <form v-else class="card mx-2 p-3" method="post" id="updateUser" @submit.prevent="updateUser">
            <!-- ACTIONS -->
            <div class="d-flex justify-content-between align-items-start mb-4">
                <button type="button" class="font-weight-bold text-primary mx-0" @click="$router.go(-1)">
                    <i class="mdi mdi-arrow-left mr-2"></i>{{ $t("profile.account.address") }}
                </button>
                <button type="submit" class="btn-pill font-weight-bold text-primary">
                    {{ $t("action.save") }}
                </button>
            </div>

            <div class="form-group mb-4">
                <div class="col-lg-12">
                    <label for="address">{{ $t("attr.address") }}</label>
                    <input type="text" :class="'form-control ' + { 'is-invalid': has_error && errors.address }"
                        id="address" v-model="userUpdate.address" />
                    <span class="help-block text-danger" v-if="has_error && errors.address">
                        {{ errors.address[0] }}
                    </span>
                </div>
            </div>

            <AddressSelector :errors="errors" :has_error="has_error" v-model="userUpdate" />

            <div class="form-group">
                <div class="row my-4 mx-1">
                    <div class="col-lg-6 mb-4 mb-md-2">
                        <label for="phone">{{ $t("attr.phone") }}</label>
                        <input type="text" :class="'form-control ' + { 'is-invalid': has_error && errors.phone }"
                            id="phone" v-model="userUpdate.phone" />
                        <span class="help-block text-danger" v-if="has_error && errors.phone">
                            {{ errors.phone[0] }}
                        </span>
                    </div>
                    <div class="col-lg-6">
                        <label for="postal_code">{{ $t("attr.postal_code") }}</label>
                        <input type="text" :class="'form-control ' + { 'is-invalid': has_error && errors.postal_code }"
                            id="postal_code" v-model="userUpdate.postal_code" />
                        <span class="help-block text-danger" v-if="has_error && errors.postal_code">
                            {{ errors.postal_code[0] }}
                        </span>
                    </div>
                </div>
            </div>
            <div v-if="
                cardIdOverview !== false ||
                (user.cardId !== undefined && user.cardId !== null && user.cardId.length > 0)
            " class="form-group row mb-5">
                <div class="col-8">
                    <div class="custom-file mb-1">
                        <img :src="cardIdOverview ? cardIdOverview : storageUrl + user.card_id" class="thumbnail" />
                    </div>
                </div>
            </div>

            <div class="form-group row mb-5">
                <div class="col-lg-12">
                    <label for="cardId" class="col-sm-4 col-lg-2 col-form-label">
                        {{ $t("ecommerce.cardId") }}
                    </label>
                    <div class="col-sm-8 col-lg-10">
                        <div class="custom-file mb-1">
                            <input type="file" :class="{ 'is-invalid': has_error && errors.cardId }" id="cardId"
                                name="cardId" ref="cardId" @change="onCardIdChange" />
                            <label class="custom-file-label" for="cardId">
                                {{ $t("action.chooseFile") }}...
                            </label>
                            <span class="help-block text-danger" v-if="has_error && errors.cardId">
                                {{ errors.cardId[0] }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <notifications style="top:5%;" width="35%" group="success" position="top center" />
        <notifications style="top:5%;" width="35%" group="error" position="top center" />
    </div>
</template>

<script>
import config from "@/config";
import AddressSelector from "@/components/templates/AddressSelector";
import LoadingSpinner from '@/components/templates/LoadingSpinner.vue';

export default {
    components: {
        AddressSelector,
        LoadingSpinner,
    },
    data() {
        return {
            userUpdate: {},
            has_error: false,
            loader: false,
            errors: {},
            cardIdOverview: false,
            storageUrl: config.storageUrl,
        };
    },
    mounted() {
        this.userUpdate=Object.assign({}, this.user);
        delete this.userUpdate.card_id;

    },
    methods: {
        onCardIdChange() {
            this.userUpdate.cardId=this.$refs.cardId.files[0];
            this.cardIdOverview=URL.createObjectURL(this.userUpdate.cardId);
        },
        updateUser() {
            var self=this;
            var formData=new FormData();
            window.scrollTo(0, 0);

            formData.append("address", self.userUpdate.address||"");
            formData.append("city", self.userUpdate.city||"");
            formData.append("postal_code", self.userUpdate.postal_code||"");

            if (self.userUpdate.cardId!==undefined&&self.userUpdate.cardId!==null) {
                formData.append("card_id", self.userUpdate.cardId);
            }

            if (self.userUpdate.commune!==undefined&&self.userUpdate.commune!==null) {
                formData.append("commune", self.userUpdate.commune);
            }

            if (self.userUpdate.phone!==undefined&&self.userUpdate.phone!==null) {
                formData.append("phone", self.userUpdate.phone);
            }

            this.loader=true;
            this.$axios({
                url: "user/update-credentials/"+self.user.id,
                method: "POST",
                data: formData,
                headers: { "Content-Type": "multipart/form-data" },
            })
                .then((response) => {
                    if (response.data&&response.data.data) {
                        self.$store.commit("setUser", { user: response.data.data });
                    } else {
                        const updatedUser=Object.assign({}, self.user, self.userUpdate);
                        self.$store.commit("setUser", { user: updatedUser });
                    }

                    this.loader=false;
                    self.has_error=false;
                    self.errors={};

                    self.$notify({
                        group: "success",
                        title: "Bravo !",
                        type: "success",
                        text: "Profil modifié avec succès!",
                    });
                })
                .catch((err) => {

                    this.loader=false;
                    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                    self.$notify({
                        group: "error",
                        title: "Erreur !",
                        type: "error",
                        text: "Une erreur est survenue !",
                    });
                    self.has_error=true;
                    self.errors=err.response.data.data||{};
                });
        },
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
};
</script>